var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-card", { staticStyle: { height: "100%" } }, [
    _c(
      "div",
      {
        staticClass: "mobile-max-300w d-chart-card",
        staticStyle: { height: "100%" },
      },
      [
        _c(
          "v-row",
          {
            staticClass: "mx-2 mt-0 mb-1",
            staticStyle: { "min-width": "500px !important" },
            attrs: { "no-gutters": "" },
          },
          [
            _vm.cardInfo.name
              ? _c(
                  "p",
                  {
                    key: _vm.chartNameRenderKey,
                    staticClass: "mb-2 mt-4 ml-3 chartTitle",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.cardInfo.name) +
                        " - " +
                        _vm._s(_vm.cardSymbol) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
            _c("v-spacer"),
            _vm.showZoomButton
              ? _c(
                  "v-btn",
                  {
                    staticClass: "absolute",
                    staticStyle: {
                      right: "115px",
                      top: "72px",
                      "z-index": "1",
                    },
                    attrs: { icon: "", small: "" },
                    on: { click: _vm.changeZoomSetting },
                  },
                  [
                    _vm.leveledZoom
                      ? _c(
                          "div",
                          [
                            _c("v-img", {
                              attrs: {
                                "max-height": "16",
                                "max-width": "16",
                                src: require("../../assets/views-images/pricewatcher/zoom.png"),
                                "x-small": "",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm.horizontalZoom && _vm.verticalZoom
                      ? _c("v-img", {
                          attrs: {
                            "max-height": "16",
                            "max-width": "16",
                            src: require("../../assets/views-images/pricewatcher/zoom_percise.png"),
                            "x-small": "",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            this.historyOption === 0 &&
            _vm.tooLongSinceLastPriceUpdate &&
            _vm.timeOverdueWatchers
              ? _c(
                  "v-tooltip",
                  {
                    staticClass: "absolute",
                    attrs: { disabled: _vm.isNotDesktop, bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "div",
                                _vm._g(
                                  {
                                    staticClass: "mr-3 mt-4",
                                    staticStyle: { position: "relative" },
                                    on: {
                                      click: function ($event) {
                                        return this.$router.push("/settings")
                                      },
                                    },
                                  },
                                  on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mt-1",
                                      staticStyle: {
                                        "font-size": "12px",
                                        "margin-right": "2px",
                                      },
                                      attrs: { small: "", color: "red" },
                                    },
                                    [_vm._v("fas fa-exclamation")]
                                  ),
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mt-1",
                                      staticStyle: { "font-size": "12px" },
                                      attrs: { small: "", color: "red" },
                                    },
                                    [_vm._v("fas fa-clock")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1526380755
                    ),
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "Haven't received any data in a while from watcher(s):"
                      ),
                      _c("br"),
                      _vm._v(" " + _vm._s(_vm.timeOverdueWatchers) + " "),
                    ]),
                  ]
                )
              : _vm._e(),
            _c(
              "p",
              {
                staticClass: "mb-0 mr-1",
                staticStyle: {
                  "font-size": "0.8125rem",
                  "padding-top": "21px",
                },
              },
              [_vm._v(" Step: ")]
            ),
            _c(
              "div",
              { staticStyle: { width: "30px !important" } },
              [
                _c("v-select", {
                  staticClass: "hide-spin-buttons chart-stepper-selector mt-1",
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    "hide-spin-buttons": "",
                    "menu-props": { bottom: true, offsetY: true },
                    height: "40px",
                    items: _vm.stepperOptions,
                    "item-text": "text",
                    "item-value": "value",
                  },
                  on: { change: _vm.stepperChanged },
                  scopedSlots: _vm._u([
                    {
                      key: "item",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mb-0 char-lim-tabs page-rows-selection",
                            },
                            [_c("div", [_vm._v(_vm._s(item.text))])]
                          ),
                        ]
                      },
                    },
                    {
                      key: "selection",
                      fn: function ({ item }) {
                        return [
                          _c("div", { staticClass: "page-rows-selection" }, [
                            _c("div", { staticClass: "primary--text" }, [
                              _vm._v(" " + _vm._s(item.text) + " "),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.stepper,
                    callback: function ($$v) {
                      _vm.stepper = $$v
                    },
                    expression: "stepper",
                  },
                }),
              ],
              1
            ),
            _c(
              "v-item-group",
              {
                staticClass: "px-2 mt-2 watcher-card-option-divider",
                staticStyle: {
                  "border-radius": "4px !important",
                  "border-right-radius": "0 !important",
                },
                style: _vm.$vuetify.theme.dark
                  ? "background: #262b2e"
                  : "background: #edeef2",
                attrs: { mandatory: "" },
                model: {
                  value: _vm.historyOption,
                  callback: function ($$v) {
                    _vm.historyOption = $$v
                  },
                  expression: "historyOption",
                },
              },
              [
                _c(
                  "v-container",
                  { staticClass: "py-2" },
                  [
                    _c(
                      "v-row",
                      _vm._l(_vm.historyOptions, function (option, i) {
                        return _c(
                          "div",
                          { key: option },
                          [
                            _c("v-item", {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ active, toggle }) {
                                      return [
                                        _c(
                                          "v-card",
                                          {
                                            staticClass:
                                              "d-flex align-center watcher-history-option",
                                            class: {
                                              selectedHistoryOption:
                                                _vm.selectedHistoryOption ===
                                                option,
                                              "active-card": active,
                                            },
                                            attrs: {
                                              color: active
                                                ? "#1C6E59"
                                                : "accent",
                                              elevation: "0",
                                              height: "30",
                                              width: "32",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.changeChartHistoryOption(
                                                  option
                                                )
                                                toggle()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-scroll-y-transition",
                                              [
                                                i === 0
                                                  ? _c(
                                                      "v-tooltip",
                                                      {
                                                        staticClass:
                                                          "mt-3 ml-1",
                                                        attrs: {
                                                          disabled:
                                                            _vm.isNotDesktop,
                                                          bottom: "",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-icon",
                                                                    _vm._g(
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "margin-left":
                                                                              "9px",
                                                                          },
                                                                        attrs: {
                                                                          "x-small":
                                                                            "",
                                                                        },
                                                                      },
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        "fas fa-broadcast-tower"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    _vm._g(
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                _vm.historyOption ===
                                                                                0,
                                                                              expression:
                                                                                "historyOption === 0",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "live_data_icon",
                                                                      },
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "circle--outer",
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "circle--inner",
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v("Live"),
                                                        ]),
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex-grow-1 text-center history-option",
                                                        staticStyle: {
                                                          "font-size":
                                                            "12px !important",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(option) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "mt-2 pr-3",
                staticStyle: {
                  height: "46px",
                  "border-radius": "0",
                  "padding-left": "20px",
                },
                style: _vm.$vuetify.theme.dark
                  ? "background: #262b2e"
                  : "background: #edeef2",
              },
              [
                _c("v-row", [
                  _c(
                    "div",
                    { staticClass: "py-2" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          staticClass: "mt-3 ml-1",
                          attrs: { disabled: _vm.isNotDesktop, bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-card",
                                    _vm._g(
                                      {
                                        staticClass:
                                          "d-flex align-center watcher-history-option",
                                        class:
                                          _vm.selectedHistoryOption === "delete"
                                            ? "selectedHistoryOption"
                                            : "",
                                        attrs: {
                                          elevation: "0",
                                          height: "30",
                                          width: "32",
                                          color: "accent",
                                        },
                                        on: { click: _vm.deleteChart },
                                      },
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass:
                                            "flex-grow-1 text-center",
                                          staticStyle: {
                                            "font-size": "12px !important",
                                          },
                                        },
                                        [_vm._v(" fa-solid fa-trash ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [_c("span", [_vm._v("Delete")])]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "py-2" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          staticClass: "mt-3 ml-1",
                          attrs: { disabled: _vm.isNotDesktop, bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-card",
                                    _vm._g(
                                      {
                                        staticClass:
                                          "d-flex align-center watcher-history-option",
                                        class:
                                          _vm.selectedHistoryOption === "delete"
                                            ? "selectedHistoryOption"
                                            : "",
                                        attrs: {
                                          elevation: "0",
                                          height: "30",
                                          width: "32",
                                          color: "accent",
                                        },
                                        on: { click: _vm.editChart },
                                      },
                                      on
                                    ),
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon-edit-21x21",
                                          class: _vm.$vuetify.theme.dark
                                            ? "ec-darkEdit"
                                            : "ec-lightEdit",
                                          staticStyle: {
                                            "font-size": "27px",
                                            "margin-bottom": "2px",
                                            "margin-left": "28px",
                                          },
                                        },
                                        [_c("span", { staticClass: "path2" })]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [_c("span", [_vm._v("Edit")])]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "py-2 pr-1" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          staticClass: "mt-3 ml-1",
                          attrs: { disabled: _vm.isNotDesktop, bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit("draggable-switch")
                                          },
                                        },
                                      },
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "dragFromHere",
                                          attrs: {
                                            color: _vm.draggable
                                              ? "primary"
                                              : "white",
                                            small: "",
                                          },
                                        },
                                        [_vm._v("fas fa-arrows-alt")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "Drag & Resize : " +
                                _vm._s(_vm.draggable ? "ON" : "OFF")
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm.initialLoading || !_vm.settingsLoaded
          ? _c("loading-page", { staticStyle: { "margin-top": "-54px" } })
          : _vm.chartError
          ? _c(
              "div",
              { staticStyle: { height: "calc(100% - 62px)", width: "100%" } },
              [
                _c(
                  "v-container",
                  {
                    staticClass: "loading",
                    staticStyle: { height: "100%" },
                    attrs: { fluid: "" },
                  },
                  [
                    _c(
                      "v-row",
                      {
                        staticStyle: { height: "100%" },
                        attrs: { align: "center", justify: "center" },
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-2 mb-1",
                            attrs: { large: "", color: "grey", small: "" },
                          },
                          [_vm._v("fas fa-exclamation-triangle")]
                        ),
                        _c("p", { staticClass: "mb-0 grey--text" }, [
                          _vm._v(" There was a problem displaying this chart "),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm.chartIsEmpty && !_vm.loadingChartsData
          ? _c(
              "div",
              { staticStyle: { height: "calc(100% - 62px)", width: "100%" } },
              [
                _c(
                  "v-container",
                  {
                    staticClass: "loading",
                    staticStyle: { height: "100%" },
                    attrs: { fluid: "" },
                  },
                  [
                    _c(
                      "v-row",
                      {
                        staticStyle: { height: "100%" },
                        attrs: { align: "center", justify: "center" },
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-2 mb-1",
                            attrs: { large: "", color: "grey", small: "" },
                          },
                          [_vm._v("fas fa-exclamation-triangle")]
                        ),
                        _c("p", { staticClass: "mb-0 grey--text" }, [
                          _vm._v("No data available"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _c(
              "div",
              {
                staticClass: "chart-wrapper",
                staticStyle: {
                  "min-width": "500px !important",
                  height: "calc(100% - 62px)",
                },
              },
              [
                _c("v-chart", {
                  ref: `chart-${_vm.cardInfo.id}`,
                  class: `chart chart-${_vm.cardInfo.id} px-4 py-0`,
                  attrs: {
                    "update-options": _vm.updateOptions,
                    option: _vm.chartOption,
                    loading:
                      (_vm.loadingChartsData || _vm.chartIsEmpty) &&
                      !_vm.initialLoading,
                    "loading-options": {
                      text: "Loading...",
                      color: "#47BD96",
                      textColor: "grey",
                      maskColor: "transparent",
                      fontFamily: "Roboto",
                    },
                    autoresize: true,
                  },
                  on: { rendered: _vm.chartRendered },
                }),
              ],
              1
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }